import type { NavigationGuardWithThis, RouteLocationNormalized, RouteLocationRaw } from 'vue-router'
import { useCommonStore } from '@/stores/CommonStore'
import { useRoute } from 'vue-router'
import { useCalendarStore } from '@/stores/CalendarStore'

const route = useRoute()

export const checkCalendar3ColumnFeatureFlags: NavigationGuardWithThis<undefined> = async (
  to: RouteLocationNormalized
): Promise<true | RouteLocationRaw> => {
  const incomingRouteName = to.name
  const startDate = to.params?.startDate
  const commonStore = useCommonStore()
  const calendarStore = useCalendarStore()
  // Ensure global feature flags are loaded
  if (!commonStore.globalFlagsLoaded) {
    await commonStore.loadRemoteConfigFlags()
  }

  if (
    commonStore.featureFlags?.web_calendar_enable3ColumnLayout &&
    !['calendar3ColumnWithDate', 'calendar3Column'].includes(incomingRouteName?.toString() ?? '')
  ) {
    if (startDate) {
      return {
        name: 'calendar3ColumnWithDate',
        state: {
          currentRoute: incomingRouteName?.toString()
        },
        params: {
          viewType: calendarStore.viewType,
          startDate: startDate
        }
      }
    } else {
      return {
        name: 'calendar3Column',
        state: {
          currentRoute: incomingRouteName?.toString()
        }
      }
    }
  } else {
    return true
  }
}
